import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=21704bd0&scoped=true&lang=pug&"
import script from "./Button.vue?vue&type=script&lang=ts&"
export * from "./Button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21704bd0",
  null
  
)

export default component.exports